<template lang="pug">
	div
		.d-flex.justify-content-between(style="border-bottom: 1px solid #e0e0e0;margin-bottom: 10px;padding-bottom:10px;")
			div(style="font-size:1.5em;font-weight:bold;")
				| Tarea {{ index + 1 }}
				.bagde.badge-success.salvado(:class="(salvado) ? 'activo': ''")
					| Cambios guardados
			.btn-group.mr-2
				button.btn.btn-sm.btn-secondary(@click="quitarTarea(index)" v-if="(tarea.fase !== 'finalizada' && tarea.esAgente) ||permisos.produccion_eliminarFinalizadas")
					span.fa.fa-trash
		.row
			.col-xs-12.col-sm-12.col-md-12.col-lg-6.col-xl-3.text-left
				.form-group
					label(for="") Tipo
					select.form-control.form-control-sm(name="" v-model="tarea.tipo" @change="guardarTarea()" :disabled="tarea.fase !== 'pteIdea'")
						option(:value="null") Selecciona
						option(value="cuna") Cuña
				.form-group(v-if="tarea.tipo === 'cuna'")
					label(for="") Duración
					.input-group.input-group-sm
						input.form-control(type="text" v-mask="'##'" v-model="tarea.duracion" @blur="guardarTarea()" :disabled="tarea.fase !== 'pteIdea'")
						.input-group-append
							.input-group-text
								| seg.
				.form-group
					label Voces externas
					.input-group.input-group-sm
						input.form-control(placeholder="0", v-model.number="tarea.vocesExternas", @blur="guardarTarea()")
						.input-group-append
							.input-group-text voces
				.form-group
					label(for="") Título
					input.form-control.form-control-sm(type="text" :disabled="tarea.fase === 'finalizada'" v-model="tarea.titulo" @blur="guardarTarea()")
				div(v-if="tarea.tipo === 'cuna'")
					.input-group.input-group-sm.mb-2
						.input-group-prepend
							.input-group-text
								span.fa.fa-info
						input-query(v-if="tarea.fase !== 'finalizada'" url="produccion/php/api/buscaSoportes.php" :realtime="true" @selected="setSoporte($event)" input-class="form-control" placeholder="Añade los soportes")
						.form-control.form-control-sm.bg-light(v-if="tarea.fase === 'finalizada'") Soportes
					button.btn.btn-info.btn-sm.mr-1.mb-1(style="font-size:0.8em" v-for="soporte in tarea.soportes" :key="soporte.ID_soporte" @click="quitaSoporte(soporte)")
						span.fa.fa-trash.mr-2.border-right-1
						| 	{{ soporte.nombre }}
			.col-xs-12.col-sm-12.col-md-12.col-lg-6.col-xl-5
				.row
					.col
						.form-group
							label(for="") Fecha inicio
							datepicker(
								:language="$dateLang"
								v-model="tarea.fecha_inicio"
								:bootstrap-styling="true"
								:monday-first="true"
								format="dd-MM-yyyy"
								@closed="guardarTarea"
								:disabled-dates="disabledInicio"
								input-class="form-control form-control-sm"
							)
							//
								input.form-control.form-control-sm(type="text" v-mask="'##/##/####'" placeholder="dd/mm/aaaa" v-model="tarea.fecha_inicio" @blur="guardarTarea()")
					.col
						.form-group
							label(for="") Fecha fin
							datepicker(
								:language="$dateLang"
								v-model="tarea.fecha_fin"
								:bootstrap-styling="true"
								:monday-first="true"
								format="dd-MM-yyyy"
								@closed="guardarTarea"
								:disabled-dates="disabledFin"
								input-class="form-control form-control-sm"
							)
							//
								input.form-control.form-control-sm(type="text" v-mask="'##/##/####'" placeholder="dd/mm/aaaa" v-model="tarea.fecha_fin" @blur="guardarTarea()")
				.form-group(v-if="tarea.tipo === 'cuna'")
					label(for="") Descripción
					textarea.form-control.form-control-sm(:disabled="tarea.fase !== 'pteIdea'" name="" :readonly="!esFaseInicial" rows="7" v-model="tarea.descripcion" @blur="guardarTarea()")
				.card.text-left(v-if="!tarea.express_fecha")
					.card-header.bg-warning
						b Tarea express
						button.pull-right.btn.btn-sm(:class="(tarea.express) ? 'btn-primary' : ''", @click="toggleExpress")
							span.fa.fa-check
					.card-body.bg-light(v-show="tarea.express")
						p Si esta tarea necesitas que se realice en menos de 48 horas, explica los motivos. Ten en cuenta que el tiempo reglamentario 
							| es de 48 horas, por lo que si solicitas una tarea express esto generará una incidencia.
						textarea.mt-2.form-control(rows="3", v-model="tarea.express_motivos", placeholder="Indica los motivos por los que necesitas acelerar el proceso de producción de esta tarea")
					.card-footer(v-show="tarea.express")
						button.btn.btn-sm.btn-primary(@click="solicitarExpress")
							span.fa.fa-star.mr-2
							| Solicitar express
				.alert.alert-warning.text-left(v-if="tarea.express_fecha")
					b 
						span.fa.fa-star.mr-2
						| Tarea express
					p
						| El agente ha solicitado que esta tarea se produzca de manera express. Los motivos son:
						br
						span(style="opacity:0.8;font-style:italic;") "{{tarea.express_motivos}}"
			.col-xs-12.col-sm-12.col-md-12.col-lg-12.col-xl-4
				table.table.table-striped.table-sm
					thead
						tr.bg-danger.text-white
							th(style="vertical-align:middle;") Ficheros
							th.text-right
								button.btn.btn-sm.btn-dark(@click="nuevoFichero(tarea)" v-if="tarea.fase !== 'finalizada'")
									span.fa.fa-plus(style="cursor:pointer;")
					tbody
						tr(v-for="fichero in tarea.ficheros" :key="fichero.ID_fichero")
							td {{ fichero.nombre }}
							td.text-right
								button.btn.btn-sm.btn-danger(@click="quitaFichero(fichero.ID_fichero)")
									span.fa.fa-trash

</template>
<script>
import API from '../../services/api'
import { mapGetters } from 'vuex'

export default {
	props: ['tarea', 'index'],
	name: 'tarea',
	data: function () {
		return {
			listadoSoportes: [],
			nuevoFicheroIndex: 0,
			salvado: false,
			disabledInicio: {
				to: new Date(new Date().getTime() + 172800000)
			},
			disabledFin: {
				to: new Date(new Date().getTime() + 172800000)
			}
		}
	},

	created () {
		API.getSoportes()
			.then(res => {
				this.listadoSoportes = res.data.soportes
			})
			.catch(e => {
				console.error(e)
			})
	},

	computed: {
		...mapGetters({
			permisos: 'permisos/permisos'
		}),
		esFaseInicial () {
			return (typeof this.tarea.fase === 'undefined' || this.tarea.fase === 'pteIdea' || this.tarea.fase === '' || this.tarea.fase === null)
		}
	},

	methods: {
		toggleExpress () {
			if (!this.tarea.express_fecha) {
				this.tarea.express = (typeof this.tarea.express === 'boolean') ? !this.tarea.express : true
			}
		},
		quitarTarea () {
			this.$store.commit('alertas/confirm', {
				titulo: 'Confirmación',
				mensaje: `¿Quieres eliminar esta tarea?
				Todos los datos relacionados (incluídos ficheros) serán eliminados.
				Esta acción no se puede deshacer.`,
				callback: (acepta) => {
					if (acepta) {
						API.delTarea(this.tarea.ID_tarea)
							.then(res => {
								this.$emit('quitar')
								this.emiteActualizar(true)
							})
							.catch(e => {
								console.error(e)
							})
					}
				}
			})
		},
		setSoporte (e) {
			const datos = {
				ID_tarea: this.tarea.ID_tarea,
				ID_soporte: e.datos.ID_soporte
			}

			API.tareaAddSoporte(datos)
				.then(res => {
					this.$emit('update:tarea', res.data.tarea)
					this.emiteActualizar()
				})
				.catch(e => {
					this.$store.commit('alertas/error', {
						titulo: 'Error',
						mensaje: e.response.data.error
					})
				})
		},
		quitaSoporte (soporte) {
			const datos = {
				ID_tarea: this.tarea.ID_tarea,
				ID_soporte: soporte.ID_soporte
			}

			API.tareaDelSoporte(datos)
				.then(res => {
					this.$emit('update:tarea', res.data.tarea)
					this.emiteActualizar()
				})
				.catch(e => {
					this.$store.commit('alertas/error', {
						titulo: 'Error',
						mensaje: e.response.data.error
					})
				})
		},

		nuevoFichero () {
			const inp = document.createElement('input')
			inp.type = 'file'
			inp.setAttribute('multiple', 'true')
			inp.addEventListener('change', (ev) => {
				const ficheros = ev.srcElement.files
				const form = new FormData()
				form.append('ID_tarea', this.tarea.ID_tarea)

				for (let i = 0; i < ficheros.length; i++) {
					form.append('fichero[]', ficheros[i])
				}

				API.tareaAddFicheros(form)
					.then(res => {
						this.$emit('update:tarea', res.data.tarea)

						this.emiteActualizar()
					})
					.catch(e => {
						console.error(e)
					})

				document.body.removeChild(inp)
			})
			inp.style.display = 'none'

			document.body.appendChild(inp)

			inp.click()
		},

		quitaFichero (idFichero) {
			this.$store.commit('alertas/confirm', {
				titulo: 'Confirmación',
				mensaje: `¿Quieres eliminar este fichero?
				Esta acción no se puede deshacer`,
				callback: (acepta) => {
					if (acepta) {
						const datos = {
							ID_tarea: this.tarea.ID_tarea,
							ID_fichero: idFichero
						}

						API.tareaDelFichero(datos)
							.then(res => {
								this.$emit('update:tarea', res.data.tarea)
								this.emiteActualizar()
							})
							.catch(e => {
								console.error(e)
							})
					}
				}
			})
		},

		solicitarExpress () {
			if (!this.tarea.express_motivos) {
				this.$error('Error', 'Debes escribir los motivos por los que solicitas esta tarea express')
				return
			}
			this.$store.commit('alertas/confirm', {
				titulo: 'Crear tarea express',
				mensaje: `Una vez crees esta tarea como express, ya no podrás cambiar su estado.
				¿Quieres continuar?`,
				callback: acepta => {
					if (acepta) {
						const datos = {
							ID_tarea: this.tarea.ID_tarea,
							motivos: this.tarea.express_motivos
						}
						API.setTareaExpress(datos)
							.then(res => {
								this.$emit('update:tarea', res.data.tarea)
								this.emiteActualizar()
								this.$store.commit('toast/success', {
									titulo: 'Tarea express',
									mensaje: 'Se ha marcado la tarea como express'
								})
							})
							.catch(this.$responseError)
					}
				}
			})
		},

		guardarTarea () {
			const tarea = JSON.parse(JSON.stringify(this.tarea))
			tarea.fecha_inicio = this.$moment(this.tarea.fecha_inicio).format('DD/MM/YYYY')
			tarea.fecha_fin = this.$moment(this.tarea.fecha_fin).format('DD/MM/YYYY')
			console.log(tarea.fecha_inicio)
			API.setTarea(tarea)
				.then(res => {
					this.$emit('update:tarea', res.data.tarea)
					this.emiteActualizar()
				})
				.catch(e => {
					console.error(e)
				})
		},
		emiteActualizar (eliminada) {
			eliminada = (typeof eliminada === 'boolean') ? eliminada : false
			this.$emit('actualizar', eliminada)

			this.salvado = true
			window.setTimeout(() => {
				this.salvado = false
			}, 2000)
		}
	}
}
</script>


<style scoped>

	.salvado {
		transition-property: opacity;
		transition-duration: 300ms;
		position: relative;
		display: inline-block;
		margin-left: 10px;
		border-radius: 4px;
		padding: 5px;
		font-size:0.8em;
		opacity: 0;
	}

	.salvado.activo {
		opacity: 1;
	}
</style>



// WEBPACK FOOTER //
// src/modulos/produccion/vue/components/nueva/tarea.vue